<template>
  <Card
    class="hover:drop-shadow-md hover:cursor-pointer rounded-lg"
    :pt:root:class="value ? ' hover:bg-success-50! dark:hover:bg-success-800!' : 'hover:bg-slate-100! dark:hover:bg-slate-700!'"
    pt:footer:class="text-center"
    @click="toggle"
  >
    <template #content>
      <div class="flex justify-center">
        <i class="pi" :class="(value ? 'text-success-500!' : 'text-slate-600! dark:text-slate-400!') + ' pi-' + props.icon + ' ' + iconSize"></i>
      </div>
    </template>
    <template #footer>
      <span class="font-bold" :class="value ? 'text-success-500!' : 'text-slate-600! dark:text-slate-400!'">{{ props.label }}</span></template
    >
  </Card>
</template>

<script setup lang="ts">
interface Props {
  label: string;
  icon: string;
  initialValue: boolean;
  iconSize?: string;
}

const props = withDefaults(defineProps<Props>(), {
  iconSize: "text-4xl",
});
const value = ref<boolean>(props.initialValue);

const emit = defineEmits<{ toggle: [value: boolean] }>();

const toggle = (): void => {
  value.value = !value.value;
  emit("toggle", value.value);
};
</script>
